<header>
    <label class="close_button" (click)="close()">x</label>
    <div class="header" style="display:block">
        <h1> {{heading}} </h1>
    </div>
</header>
<div class="body" [style]="errormsg? 'margin: 1% 2% 0% 3%;':  'margin: 1% 2% 4.8% 3%;'">
    <br>
    <div class="row periodDialogrow periodDialogRow">
        <div class="col-4">

            <label class="catlabel">Period<span style="color:#ff0000">*</span></label>

        </div>
        <div class="col-8">
            <span class="content">
                <select [(ngModel)]="selected_period_id" [ngModelOptions]="{standalone: true}" [disabled]="isPeriodDDDisabled"
                    style="font-family:Roboto;font-size:13px" class="drpdwn_period">
                    <option *ngFor="let period of periodData" [value]="period.periodId">
                        {{period.period}}
                    </option>
                </select>
            </span>
        </div>

    </div>
    <div class="row periodDialogRow">
        <div class="col-4">

            <label class="catlabel">Midwest Crossdock<span style="color:#ff0000">*</span></label>

        </div>
        <div class="col-8">
            <span class="content">
                <input type="date" onkeypress="return false" class="category"
                    (change)="dateChangeToAPI('crossDockStart')" [(ngModel)]="crossDockStart">
            </span>
            <label class="drpdwn_period_label">to</label>
            <span class="content">
                <input type="date" onkeypress="return false" class="category" (change)="dateChangeToAPI('crossDockEnd')"
                    [(ngModel)]="crossDockEnd">
            </span>

        </div>
    </div>
    <div class="row periodDialogRow">
        <div class="col-4">

            <label class="catlabel">PSC<span style="color:#ff0000">*</span></label>

        </div>
        <div class="col-8">
            <span class="content">
                <input type="date" onkeypress="return false" class="category" (change)="dateChangeToAPI('midWestStart')"
                    [(ngModel)]="midWestStart">
            </span>
            <label class="drpdwn_period_label">to</label>
            <span class="content">
                <input type="date" onkeypress="return false" class="category" (change)="dateChangeToAPI('midWestEnd')"
                    [(ngModel)]="midWestEnd">
            </span>

        </div>
    </div>
    <div class="row periodDialogRow">
        <div class="col-4">

            <label class="catlabel">NAMC<span style="color:#ff0000">*</span></label>

        </div>
        <div class="col-8">
            <span class="content">
                <input type="date" onkeypress="return false" class="category"
                    (change)="dateChangeToAPI('westCoastStart')" [(ngModel)]="westCoastStart">
            </span>
            <label class="drpdwn_period_label">to</label>
            <span class="content">
                <input type="date" onkeypress="return false" class="category" (change)="dateChangeToAPI('westCoastEnd')"
                    [(ngModel)]="westCoastEnd">
            </span>

        </div>
    </div>

</div>

<label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
<div class=" footer">
    <button (click)="onNoClick()" class="cancel"
        style="display: inline; background: transparent;border: none !important;"> CANCEL </button>
    <button mat-raised-button class="submit" style="display: inline;" (click)="saveClick()">SAVE</button>
</div>